import { jsx as _jsx } from "react/jsx-runtime";
import { Input, TextArea } from '@dossierhq/design';
export function StringFieldDisplay({ fieldSpec, value }) {
    return fieldSpec.multiline ? (_jsx(TextArea, { value: value ?? '', readOnly: true })) : (_jsx(Input, { value: value ?? '', readOnly: true }));
}
//# sourceMappingURL=StringFieldDisplay.js.map